'use strict';

import _ from 'lodash';

import React from 'react';
import PropTypes from 'prop-types';
import TextInput from './TextInput.jsx';
import EmailVerifier from 'ck-core/source/verifiers/user/EmailVerifier';

const Mailcheck = require('mailcheck');
_.remove(Mailcheck.defaultSecondLevelDomains, domain => domain === 'hotmail');
Mailcheck.defaultDomains.push('hotmail.com');

export default class EmailInput extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			suggestion: null
		};

		this.onBlur = this.onBlur.bind(this);

		this.validate = this.validate.bind(this);
	}

	onBlur(event) {
		const empty = () =>
			this.setState({
				suggestion: null
			});

		Mailcheck.run({
			email: this.props.value,
			suggested: suggestion => {
				this.setState({
					suggestion: (
						<p className="suggestion">
							Did you mean to type{' '}
							<a
								href="#"
								onClick={() => {
									this.props.onChange(suggestion.full);
									empty();
								}}
							>
								{suggestion.full}
							</a>?
						</p>
					)
				});

				CK.trackAnalytic('MailcheckSuggestionUsed', {
					old: this.props.value,
					new: suggestion
				});
			},
			empty
		});

		if (this.props.onBlur) {
			this.props.onBlur(event);
		}
	}

	async validate(value) {
		const verifier = new EmailVerifier({
			checkForDuplicates: this.props.checkForDuplicates
		});

		try {
			await verifier.verify(value, true);

			return {
				valid: true
			};
		} catch (err) {
			return {
				valid: false,
				error: err.message
			};
		}
	}

	render() {
		return (
			<div className="EmailInput">
				<TextInput
					{...this.props}
					type="email"
					autoComplete="email"
					onBlur={this.onBlur}
					validate={this.validate}
				/>
				{this.state.suggestion}
			</div>
		);
	}
}

EmailInput.defaultProps = {
	label: 'Email',
	placeholder: 'name@example.com',
	checkForDuplicates: false
};

EmailInput.propTypes = {
	value: PropTypes.string,
	label: PropTypes.string,
	explanatoryText: PropTypes.string,
	onChange: PropTypes.func,
	onBlur: PropTypes.func,
	onValidate: PropTypes.func,
	checkForDuplicates: PropTypes.bool,
	style: PropTypes.object,
	noLabel: PropTypes.bool
};
